import { render, staticRenderFns } from "./Glossary.vue?vue&type=template&id=54e09bb3"
import script from "./Glossary.vue?vue&type=script&lang=js"
export * from "./Glossary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports